import type { User } from 'firebase/auth';
import nookies from 'nookies';
import { clearFeedPositions } from '../shared/utils/feed-position';

const TOKEN_COOKIE = 'token';
const TOKEN_COOKIE_MAX_AGE_SECONDS = 55 * 60;
// Yetki taşımayan düzen ipucu: kimlik çerezi (55 dk) dolsa da ana sayfa SSR'ı panoyu çizer,
// hero → pano kayması olmaz. Erişim kararı bu çereze asla bağlanmaz.
export const SIGNED_IN_HINT_COOKIE = 'signed_in';
const SIGNED_IN_HINT_MAX_AGE_SECONDS = 30 * 24 * 3600;
const TOKEN_REQUEST_TIMEOUT_MS = 12_000;

const cookieOptions = {
  path: '/',
  sameSite: 'lax' as const,
  secure: process.env.NODE_ENV === 'production',
};

export async function persistAuthSession(user: User): Promise<void> {
  let timeoutId: ReturnType<typeof setTimeout> | undefined;
  const timeout = new Promise<never>((_, reject) => {
    timeoutId = setTimeout(
      () => reject(new Error('Kimlik doğrulama zaman aşımına uğradı.')),
      TOKEN_REQUEST_TIMEOUT_MS,
    );
  });
  const token = await Promise.race([user.getIdToken(), timeout]).finally(() => {
    if (timeoutId) clearTimeout(timeoutId);
  });
  nookies.set(null, TOKEN_COOKIE, token, {
    ...cookieOptions,
    maxAge: TOKEN_COOKIE_MAX_AGE_SECONDS,
  });
  nookies.set(null, SIGNED_IN_HINT_COOKIE, '1', {
    ...cookieOptions,
    maxAge: SIGNED_IN_HINT_MAX_AGE_SECONDS,
  });
}

export function clearAuthSession(): void {
  clearFeedPositions();
  nookies.destroy(null, TOKEN_COOKIE, cookieOptions);
  nookies.destroy(null, SIGNED_IN_HINT_COOKIE, cookieOptions);
}

export function safeLocalRedirect(value: string | string[] | undefined): string {
  const requested = Array.isArray(value) ? value[0] : value;
  if (!requested || !requested.startsWith('/') || requested.startsWith('//') || /[\\\u0000-\u001f\u007f]/.test(requested)) return '/';
  return requested;
}
